<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>睿世力购物</el-breadcrumb-item>
      <el-breadcrumb-item>眼镜用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入手机号码" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.sn" @keyup.enter.native="clicksearch" placeholder="请输入保修卡号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Id" label="编号" min-width="5%"></el-table-column>
          <el-table-column prop="Age" label="年龄" min-width="10%"></el-table-column>
          <el-table-column prop="Phone" label="手机号码" min-width="10%"></el-table-column>
          <el-table-column prop="Sn" label="保修卡号" min-width="10%"></el-table-column>
          <el-table-column prop="Unlockdegree1s" label="度数1" min-width="10%"></el-table-column>
          <el-table-column prop="Unlockdegree2s" label="度数2" min-width="10%"></el-table-column>
          <el-table-column prop="Delaytime" label="到期时间" min-width="10%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="15%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="SubRule_MiniProgramRuiShiLiGouWuGlassUsersAddEdit" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickChangeSn(scope.row)">修改</el-button>
              <el-button v-if="SubRule_MiniProgramRuiShiLiGouWuGlassUsersAddEdit" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickUnbindSn(scope.row)">清空SN</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickOldSnList(scope.row)">更换记录</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goTimeView(scope.row)">时长记录</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 新增 start -->
      <el-tab-pane label="新增" name="third" v-if="SubRule_MiniProgramRuiShiLiGouWuGlassUsersAddEdit">
        <el-form :model="addForm" ref="addFormRef" label-width="170px">
          <el-form-item label="年龄" class="addAdminForm">
            <el-input v-model="addForm.age"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" class="addAdminForm">
            <el-input v-model="addForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="密码" class="addAdminForm">
            <el-input v-model="addForm.pwd"></el-input>
          </el-form-item>
          <el-form-item label="保修卡号" class="addAdminForm">
            <el-input v-model="addForm.sn"></el-input>
          </el-form-item>
          <el-form-item label="度数" class="addAdminForm">
            <el-select v-model="addForm.degree" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择度数" value="10000"></el-option>
              <el-option label="+200" value="200"></el-option>
              <el-option label="+175" value="175"></el-option>
              <el-option label="+150" value="150"></el-option>
              <el-option label="+125" value="125"></el-option>
              <el-option label="+100" value="100"></el-option>
              <el-option label="+75" value="75"></el-option>
              <el-option label="+50" value="50"></el-option>
              <el-option label="+25" value="25"></el-option>
              <el-option label="0" value="0"></el-option>
              <el-option label="-25" value="-25"></el-option>
              <el-option label="-50" value="-50"></el-option>
              <el-option label="-75" value="-75"></el-option>
              <el-option label="-100" value="-100"></el-option>
              <el-option label="-125" value="-125"></el-option>
              <el-option label="-150" value="-150"></el-option>
              <el-option label="-175" value="-175"></el-option>
              <el-option label="-200" value="-200"></el-option>
              <el-option label="-225" value="-225"></el-option>
              <el-option label="-250" value="-250"></el-option>
              <el-option label="-275" value="-275"></el-option>
              <el-option label="-300" value="-300"></el-option>
              <el-option label="-325" value="-325"></el-option>
              <el-option label="-350" value="-350"></el-option>
              <el-option label="-375" value="-375"></el-option>
              <el-option label="-400" value="-400"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="apiRuiShiLiGouWuGlassuserAdd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 新增 end -->

      <!-- 修改 start -->
      <el-tab-pane label="修改" name="second" disabled="disabled">
        <el-form :model="editForm" ref="editFormRef" label-width="170px">
          <el-form-item label="年龄" class="addAdminForm">
            <el-input v-model="editForm.age"></el-input>
          </el-form-item>
          <el-form-item label="度数1" class="addAdminForm">
            <el-select v-model="editForm.unlockdegree1" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择度数" value="10000"></el-option>
              <el-option label="+200" value="200"></el-option>
              <el-option label="+175" value="175"></el-option>
              <el-option label="+150" value="150"></el-option>
              <el-option label="+125" value="125"></el-option>
              <el-option label="+100" value="100"></el-option>
              <el-option label="+75" value="75"></el-option>
              <el-option label="+50" value="50"></el-option>
              <el-option label="+25" value="25"></el-option>
              <el-option label="0" value="0"></el-option>
              <el-option label="-25" value="-25"></el-option>
              <el-option label="-50" value="-50"></el-option>
              <el-option label="-75" value="-75"></el-option>
              <el-option label="-100" value="-100"></el-option>
              <el-option label="-125" value="-125"></el-option>
              <el-option label="-150" value="-150"></el-option>
              <el-option label="-175" value="-175"></el-option>
              <el-option label="-200" value="-200"></el-option>
              <el-option label="-225" value="-225"></el-option>
              <el-option label="-250" value="-250"></el-option>
              <el-option label="-275" value="-275"></el-option>
              <el-option label="-300" value="-300"></el-option>
              <el-option label="-325" value="-325"></el-option>
              <el-option label="-350" value="-350"></el-option>
              <el-option label="-375" value="-375"></el-option>
              <el-option label="-400" value="-400"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="度数2" class="addAdminForm">
            <el-select v-model="editForm.unlockdegree2" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择度数" value="10000"></el-option>
              <el-option label="+200" value="200"></el-option>
              <el-option label="+175" value="175"></el-option>
              <el-option label="+150" value="150"></el-option>
              <el-option label="+125" value="125"></el-option>
              <el-option label="+100" value="100"></el-option>
              <el-option label="+75" value="75"></el-option>
              <el-option label="+50" value="50"></el-option>
              <el-option label="+25" value="25"></el-option>
              <el-option label="0" value="0"></el-option>
              <el-option label="-25" value="-25"></el-option>
              <el-option label="-50" value="-50"></el-option>
              <el-option label="-75" value="-75"></el-option>
              <el-option label="-100" value="-100"></el-option>
              <el-option label="-125" value="-125"></el-option>
              <el-option label="-150" value="-150"></el-option>
              <el-option label="-175" value="-175"></el-option>
              <el-option label="-200" value="-200"></el-option>
              <el-option label="-225" value="-225"></el-option>
              <el-option label="-250" value="-250"></el-option>
              <el-option label="-275" value="-275"></el-option>
              <el-option label="-300" value="-300"></el-option>
              <el-option label="-325" value="-325"></el-option>
              <el-option label="-350" value="-350"></el-option>
              <el-option label="-375" value="-375"></el-option>
              <el-option label="-400" value="-400"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="新保修卡号(需要修改时再填写)" class="addAdminForm">
            <el-input v-model="editForm.sn"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 修改 end -->

      <!-- 保修卡号更换记录 start -->
      <el-tab-pane label="保修卡号更换记录" name="three" disabled="disabled">
        <el-button type="primary" @click="clickreturn">返回</el-button>
        <!-- 数据列表 start -->
        <el-table :data="dataOldSnList" border stripe>
          <el-table-column prop="Oldsn" label="旧保修卡号" min-width="10%"></el-table-column>
          <el-table-column prop="Newsn" label="新保修卡号" min-width="10%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="15%"></el-table-column>
        </el-table>
        <!-- 数据列表 end -->
      </el-tab-pane>
      <!-- 保修卡号更换记录 end -->

      <el-tab-pane label="时长记录" name="four" disabled="disabled">
        <RslEvCpuidTime ref="SubVueFour" v-on:triggerFunc="BackToFirst"></RslEvCpuidTime>
      </el-tab-pane>

  </el-tabs>
  </div>
</template>

<script>
import RslEvCpuidTime from '@/componentsSubVue/RslEvCpuidTime.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RslEvCpuidTime
  },
  name: 'MyMiniProgramRuiShiLiGouWuGlassUsers',
  data () {
    return {
      activeName: 'first',
      addForm: {
        age: '',
        phone: '',
        pwd: '',
        sn: '',
        degree: '10000'
      },
      editForm: {
        glassuserid: '',
        age: '',
        sn: '',
        unlockdegree1: '10000',
        unlockdegree2: '10000'
      },
      // 查询
      keywords: {
        phone: '',
        sn: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dataOldSnList: [],
      SubRule_MiniProgramRuiShiLiGouWuGlassUsersAddEdit: false,
    }
  },
  mounted () {
    this.apiRuiShiLiGouWuGlassuserGetNum()
    this.apiRuiShiLiGouWuGlassuserGetList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_MiniProgramRuiShiLiGouWuGlassUsersAddEdit', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MiniProgramRuiShiLiGouWuGlassUsersAddEdit = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiRuiShiLiGouWuGlassuserGetNum()
      this.apiRuiShiLiGouWuGlassuserGetList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiRuiShiLiGouWuGlassuserGetList()
    },
    clickChangeSn (row) {
      this.activeName = 'second'
      this.editForm.glassuserid = row.Id
      this.editForm.age = row.Age
      this.editForm.unlockdegree1 = row.Unlockdegree1.toString()
      this.editForm.unlockdegree2 = row.Unlockdegree2.toString()
    },
    clickUnbindSn (row) {
      this.editForm.glassuserid = row.Id
      this.$confirm('是否清空SN?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiRuiShiLiGouWuGlassuserUnbind()
      })
    },
    clickOldSnList(row){
      this.activeName = "three"
      this.apiRuiShiLiGouWuGlassuserOldSnGetList(row.Id)
    },
    goTimeView(row){
      this.activeName = 'four'
      this.$refs.SubVueFour.LoadData(row)
    },
    clicksave () {
      this.apiRuiShiLiGouWuGlassuserNewSn()
    },
    clickreturn () {
      this.activeName = 'first'
      this.apiRuiShiLiGouWuGlassuserGetNum()
      this.apiRuiShiLiGouWuGlassuserGetList()
    },
    apiRuiShiLiGouWuGlassuserGetNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        phone: that.keywords.phone,
        sn: that.keywords.sn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiShiLiGouWuGlassuserGetNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiRuiShiLiGouWuGlassuserGetList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        phone: that.keywords.phone,
        sn: that.keywords.sn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiShiLiGouWuGlassuserGetList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiRuiShiLiGouWuGlassuserOldSnGetList: function (glassuserid) {
      var that = this
      that.dataOldSnList = []
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: glassuserid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiShiLiGouWuGlassuserOldSnGetList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataOldSnList = response.data.List
          }
          console.log(response.data)
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiRuiShiLiGouWuGlassuserNewSn: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiShiLiGouWuGlassuserNewSn, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiRuiShiLiGouWuGlassuserGetNum()
            that.apiRuiShiLiGouWuGlassuserGetList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiRuiShiLiGouWuGlassuserUnbind: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiShiLiGouWuGlassuserUnbind, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiRuiShiLiGouWuGlassuserGetNum()
            that.apiRuiShiLiGouWuGlassuserGetList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiRuiShiLiGouWuGlassuserAdd: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.addForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiShiLiGouWuGlassuserAdd, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
